import React, { useState } from 'react';
import styled from 'styled-components';
import { Input, Spin } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import { Redirect } from 'react-router-dom';
import { Box, LoginHeading, InputsContainer, ErrorContainer, ButtonContainer } from './shared/AuthComponents';
import BaconButton from '../../shared/components/Button';
import AUTH_MUTATIONS from '../../graphql/auth/mutations';
import { setUserLogin } from '../../shared/utils/auth';
import { useUserContext } from '../../shared/hooks';
import { getError } from '../../shared/utils/errors';
import { useAPIError } from '../../shared/hooks';


const MessageContainer = styled.p`
  font-size:14px;
`;


const PasswordScreen = () => {

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const [redirect, setRedirect] = useState(false);

  const [error, setError] = useState('');

  const userConsumer = useUserContext();
  const { addError } = useAPIError();

  const [changePassword, { loading }] = useMutation(AUTH_MUTATIONS.AUTH_CHANGE_PASSWORD, {
    onCompleted (data) {
      setError('');
      if (typeof data?.changePasswordResponse?.user?.password_update_required === 'boolean') {
        const responseUser = data?.changePasswordResponse?.user;
        setUserLogin({
          accessToken: data?.changePasswordResponse?.access_token,
          rt: data?.changePasswordResponse?.refresh_token,
          userConsumer,
          userId: responseUser.id,
          userIsAdmin: responseUser.is_admin,
          eulaAccepted: responseUser.eula_accepted,
          permissions: responseUser.permissions,
          passwordUpdateRequired: responseUser.password_update_required,
          username: userConsumer.user.username,
        });
        setRedirect(true);
      }
    }
  });

  if (redirect) {
    return <Redirect to="/" />;
  }

  const onClickHandler = () => {
    if (oldPassword && newPassword) {
      const variables = {
        oldPassword,
        newPassword,
      };
      changePassword({ variables }).catch(error => {
        const { errorMessage, errorStatus } = getError(error);
        addError(errorMessage, errorStatus);
        setError(Object.values(errorMessage)[0]);
      });
    }
  };

  return (
    <Box>
      <LoginHeading>
        Bacon Grease
      </LoginHeading>
      Frictionless Bacon Management
      <InputsContainer>
        <>
          <MessageContainer>Please update to a new permanent password.</MessageContainer>
          <Input.Password
            placeholder="Old Password"
            size="small"
            value={oldPassword}
            onChange={e => setOldPassword(e.target.value)}
            onPressEnter={onClickHandler}
          />
          <Input.Password
            placeholder="New Password"
            size="small"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            onPressEnter={onClickHandler}
          />
        </>
        <ErrorContainer>{loading ? <Spin /> : error}</ErrorContainer>
      </InputsContainer>
      <ButtonContainer>
        <BaconButton text="Save" onClick={onClickHandler}></BaconButton>
      </ButtonContainer>
    </Box>
  );
};

export default PasswordScreen;